<dx-popup
    #accEditor
    minWidth="150px"
    minHeight="150px"
    width="70%"
    height="95%"
    [title]="popupTitle"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onHidden()"
    (onHiding)="onClosePopup()"
>
    <div *dxTemplate="let item of 'content'" class="cc-application-editor">
        <dx-box height="100%" width="100%" direction="col" class="application-editor-box">
            <dxi-item baseSize="auto">
                <dx-form
                    #accEditorForm
                    [colCount]="2"
                    width="100%"
                    height="100%"
                    [labelLocation]="defaultLabelLocation"
                >
                    <dxi-item>
                        <div *dxTemplate>
                            <strong class="header-title">Project Details</strong>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-toolbar *ngIf="!!projectData?.communityId">
                                <dxi-item location="after">
                                    <div *dxTemplate class="padding-left">
                                        <app-hyperlink-creator
                                            mode="hyperlinkOnly"
                                            textLocation="right"
                                            [displayText]="
                                                projectAttachmentCount > 0 ? '(' + projectAttachmentCount + ')' : ''
                                            "
                                            (onLinkClick)="onProjectDocAttachmentClick()"
                                        >
                                            <i
                                                title="Project Documents"
                                                class="fa-2x dx-theme-accent-as-text-color"
                                                [ngClass]="iconAttach"
                                            ></i>
                                        </app-hyperlink-creator>
                                    </div>
                                </dxi-item>

                                <dxi-item
                                    location="after"
                                    [visible]="
                                        popupTitle !== 'Add Application' &&
                                        editorData.allowProjectNotesLogs &&
                                        !allowLimitedAccess
                                    "
                                >
                                    <div *dxTemplate class="padding-left">
                                        <app-notes-icon
                                            cssClass="fa-2x"
                                            title="Internal Project Notes"
                                            [hasNotes]="editorData.hasProjectNotes"
                                            (onNotesClick)="onProjectNotesClick()"
                                        ></app-notes-icon>
                                    </div>
                                </dxi-item>

                                <dxi-item
                                    location="after"
                                    [visible]="
                                        popupTitle !== 'Add Application' &&
                                        editorData.allowProjectNotesLogs &&
                                        !allowLimitedAccess
                                    "
                                >
                                    <div *dxTemplate class="padding-left">
                                        <div class="cc-hyperlink" (click)="onTransactionLogClick()">
                                            <i
                                                title="Internal Project Log"
                                                class="fa-2x dx-theme-accent-as-text-color"
                                                [ngClass]="iconLog"
                                            ></i>
                                        </div>
                                    </div>
                                </dxi-item>
                                <dxi-item location="after">
                                    <div *dxTemplate class="padding-left">
                                        <div class="cc-hyperlink" (click)="onBoardApprovalClick()">
                                            <i
                                                title="Board Approval"
                                                class="fa-2x cc-icon-check"
                                                [ngClass]="iconCheck"
                                            ></i>
                                        </div>
                                    </div>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>

                    <dxi-item [isRequired]="true">
                        <dxo-label text="Property"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                stylingMode="outlined"
                                placeholder="Please enter atleast 3 character"
                                [showClearButton]="true"
                                [readOnly]="
                                    popupTitle !== 'Add Application' ||
                                    !!linkedEmailId ||
                                    allowLimitedAccess ||
                                    (!!communityId && !!customerId)
                                "
                                [(value)]="searchText"
                                (onEnterKey)="onSearchClick()"
                            >
                                <dxi-button
                                    *ngIf="popupTitle === 'Add Application' && !linkedEmailId"
                                    name="search"
                                    location="after"
                                    [options]="{
                                        icon: 'more',
                                        type: 'default',
                                        disabled: searchText.length < 3 || (!!communityId && !!customerId),
                                        onClick: onSearchClick
                                    }"
                                ></dxi-button>
                                <dxi-button name="clear" location="before"></dxi-button>
                            </dx-text-box>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Prior Owner"></dxo-label>
                        <div *dxTemplate>
                            <dx-switch
                                switchedOnText="Yes"
                                switchedOffText="No"
                                [(value)]="isPriorOwner"
                                [disabled]="true"
                                [elementAttr]="{ class: 'switch-field' }"
                            ></dx-switch>
                        </div>
                    </dxi-item>

                    <dxi-item [isRequired]="true">
                        <dxo-label text="Community"></dxo-label>
                        <div *dxTemplate>
                            <span *ngIf="!!projectData.communityId">
                                <app-property-community-link
                                    [communityId]="
                                        popupTitle !== 'Add Application'
                                            ? editorData.projectData?.communityId
                                            : projectData.communityId
                                    "
                                    [displayText]="editorData.community"
                                ></app-property-community-link>
                            </span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Submitted by"></dxo-label>
                        <div *dxTemplate>
                            <span *ngIf="!!projectData.customerId">
                                <app-property-community-link
                                    [communityId]="projectData.communityId"
                                    [customerId]="projectData.customerId"
                                    [displayText]="editorData.owner"
                                ></app-property-community-link>
                            </span>
                        </div>
                    </dxi-item>

                    <dxi-item [colSpan]="2" [isRequired]="true">
                        <dxo-label text="Project Description"></dxo-label>
                        <div *dxTemplate>
                            <div class="project-text-area">
                                <dx-text-area
                                    width="70%"
                                    [height]="25"
                                    [maxLength]="100"
                                    [(value)]="projectData.description"
                                    (onKeyUp)="onTextAreaKeyUp($event)"
                                    [readOnly]="allowLimitedAccess"
                                >
                                    <dx-validator>
                                        <dxi-validation-rule
                                            type="required"
                                            message="Project description is required"
                                        ></dxi-validation-rule>
                                        <dxi-validation-rule
                                            type="stringLength"
                                            [min]="10"
                                            message="10-100 Characters Required."
                                        ></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-area>
                            </div>

                            <div class="remaining-words">
                                <small [ngClass]="{ 'cc-text-required': remainingWords === 0 }">
                                    Characters left: {{ remainingWords }}
                                </small>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="group" [colSpan]="2" [colCount]="3">
                        <dxi-item>
                            <dxo-label text="Received from Owner"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    type="date"
                                    [(value)]="projectData.receivedDate"
                                    [readOnly]="allowLimitedAccess"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Assigned To"></dxo-label>
                            <div *dxTemplate>
                                <app-multi-column-selector
                                    #assignedToSelector
                                    [name]="'Assigned To'"
                                    [gridSource]="editorData.usersForAssignment"
                                    [boxValue]="assignTogridBoxValue"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 570 }"
                                    [valueExpr]="'userId'"
                                    [displayExpr]="'name'"
                                    [columnDef]="assignToColumns"
                                    [showClearButton]="true"
                                    [placeholder]="'Select User...'"
                                    [readOnly]="allowLimitedAccess"
                                    (gridSelectionEvent)="onAssignedToSelection($event.selectedRow)"
                                ></app-multi-column-selector>
                            </div>
                        </dxi-item>
                        <dxi-item itemType="empty"></dxi-item>
                    </dxi-item>

                    <dxi-item itemType="group" [colSpan]="2" [colCount]="3">
                        <dxi-item>
                            <dxo-label text="Last Modified By"></dxo-label>
                            <div *dxTemplate>
                                {{ editorData?.lastModifiedBy?.displayName }}
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Last Modified On"></dxo-label>
                            <div *dxTemplate>
                                {{ editorData?.lastModifiedDate | date: dateFormat }}
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <hr />
                <div class="line-items">
                    <strong class="header-title">Line Items</strong>
                </div>
                <dx-toolbar width="100%" class="line-item-toolbar">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <div class="show-finalized-items">
                                <span class="finalized-items-text">Show Finalized Items</span>
                                <dx-switch
                                    switchedOnText="Yes"
                                    switchedOffText="No"
                                    [elementAttr]="{ class: 'switch-field' }"
                                    [(value)]="showFinalizedItem"
                                    (onValueChanged)="onShowFinalizeItemsClick()"
                                ></dx-switch>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" *ngIf="!allowLimitedAccess">
                        <div *dxTemplate>
                            <div class="new-line-item-btn">
                                <dx-button
                                    text="New Line Item"
                                    type="default"
                                    [width]="135"
                                    [height]="26"
                                    [disabled]="!projectData.customerId"
                                    (onClick)="onAddNewLineItem()"
                                    [template]="'buttonTemplate'"
                                >
                                    <div *dxTemplate="let buttonData of 'buttonTemplate'">
                                        <div class="button-item-container">
                                            <i class="dx-icon-plus"></i>
                                            <div class="button-content">{{ buttonData.text }}</div>
                                            <app-security-info
                                                iconColor="cc-white-icon"
                                                securityIndicator="LOCK"
                                                apiAction="PUT"
                                                apiUrl="api/acc"
                                            ></app-security-info>
                                        </div>
                                    </div>
                                </dx-button>
                            </div>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
            <dxi-item [ratio]="1" *ngIf="!!editorData">
                <div *dxTemplate>
                    <cc-data-grid-features #lineItemGridFeatures [dataSource]="accEditorItems">
                        <dx-data-grid
                            #lineItemGrid
                            appHasInternalUserColumns
                            class="cc-vertical-center-cell-data-grid"
                            width="100%"
                            height="100%"
                            [columnMinWidth]="100"
                            [dataSource]="accEditorItems"
                        >
                            <dxo-load-panel [enabled]="true"></dxo-load-panel>
                            <ng-container *ngIf="!allowLimitedAccess">
                                <dxi-column
                                    type="buttons"
                                    caption="Action"
                                    alignment="center"
                                    headerCellTemplate="lockHeaderCellTemplate"
                                    cellTemplate="actionTemplate"
                                    [showInColumnChooser]="false"
                                ></dxi-column>
                            </ng-container>

                            <dxi-column dataField="accItemId" dataType="string" caption="Item #"></dxi-column>
                            <dxi-column dataField="categoryId" dataType="number" caption="Category" [width]="185">
                                <dxo-lookup
                                    [dataSource]="editorData.category"
                                    valueExpr="key"
                                    displayExpr="displayText"
                                ></dxo-lookup>
                            </dxi-column>
                            <dxi-column
                                dataField="dueDate"
                                dataType="date"
                                caption="Due Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="daysRemaining"
                                dataType="number"
                                alignment="left"
                                caption="Days Remaining"
                                cellTemplate="daysRemainingTemplate"
                            ></dxi-column>
                            <dxi-column dataField="statusId" dataType="number" caption="Status" [width]="150">
                                <dxo-lookup
                                    [dataSource]="editorData.statusResult"
                                    valueExpr="key"
                                    displayExpr="displayText"
                                ></dxo-lookup>
                            </dxi-column>
                            <dxi-column
                                dataField="committeeSubmittedDate"
                                dataType="date"
                                caption="Commitee Submit Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column dataField="description" dataType="string" caption="Description"></dxi-column>

                            <dxi-column
                                dataField="itemAttachments"
                                dataType="number"
                                caption="Docs"
                                alignment="center"
                                cellTemplate="attachmentTemplate"
                            ></dxi-column>

                            <dxi-column
                                dataField="hasNotes"
                                dataType="string"
                                caption="Discussion Notes"
                                alignment="center"
                                cellTemplate="notesTemplate"
                            ></dxi-column>

                            <dxi-column caption="Logs" alignment="center" cellTemplate="logTemplate"></dxi-column>

                            <dxi-column dataField="allowanceCategoryId" dataType="string" caption="Allowance Category">
                                <dxo-lookup
                                    displayExpr="displayText"
                                    valueExpr="key"
                                    [dataSource]="editorData.allowanceCategory"
                                ></dxo-lookup>
                            </dxi-column>
                            <dxi-column
                                dataField="allowanceSubCategoryId"
                                dataType="string"
                                caption="Allowance Sub-Category"
                            >
                                <dxo-lookup
                                    displayExpr="allowanceSubCategoryName"
                                    valueExpr="allowanceSubCategoryId"
                                    [dataSource]="editorData.allowanceSubCategory"
                                ></dxo-lookup>
                            </dxi-column>
                            <dxi-column
                                dataField="allowanceStartDate"
                                dataType="date"
                                caption="Allowance Start Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="allowanceEndDate"
                                dataType="date"
                                caption="Allowance End Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="finalized"
                                dataType="boolean"
                                caption="Finalize"
                                cellTemplate="booleanCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataField="depositAmount"
                                caption="Deposit Amount"
                                [format]="currencyFormat"
                                [visible]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="depositRef"
                                dataType="string"
                                caption="Deposit Ref #"
                                [visible]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="depositStatusId"
                                dataType="string"
                                caption="Deposit Status"
                                [visible]="false"
                            >
                                <dxo-lookup
                                    displayExpr="displayText"
                                    valueExpr="key"
                                    [dataSource]="editorData.depositStatus"
                                ></dxo-lookup>
                            </dxi-column>
                            <dxi-column
                                dataField="depositTypeId"
                                dataType="string"
                                caption="Deposit Type"
                                [visible]="false"
                            >
                                <dxo-lookup
                                    displayExpr="displayText"
                                    valueExpr="key"
                                    [dataSource]="editorData.depositType"
                                ></dxo-lookup>
                            </dxi-column>
                            <dxi-column
                                dataField="responseToOwner"
                                dataType="string"
                                caption="Response to Owner"
                                [visible]="false"
                            ></dxi-column>

                            <div
                                *dxTemplate="let t of 'actionTemplate'"
                                (click)="onActionTemplateClick(t.data, t.rowIndex)"
                            >
                                <app-grid-actions-menu
                                    #gridActions
                                    [actionMenuItems]="actionMenuItems"
                                    [record]="t.data"
                                    [rowIndex]="t.rowIndex"
                                    [isActionVisible]="isActionVisible"
                                    (onActionClick)="onActionItemClick($event)"
                                ></app-grid-actions-menu>
                            </div>

                            <div *dxTemplate="let data of 'daysRemainingTemplate'">
                                <div *ngIf="data.value < 0" class="cc-text-required">
                                    {{ data.value * -1 }} days overdue
                                </div>
                                <div *ngIf="data.value >= 0">{{ data.value }} days remaining</div>
                            </div>

                            <div *dxTemplate="let row of 'attachmentTemplate'">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    textLocation="right"
                                    [displayText]="
                                        row.data.itemAttachments.length > 0
                                            ? '(' + row.data.itemAttachments.length + ')'
                                            : ''
                                    "
                                    (onLinkClick)="onLineItemAttachmentClick(row.data)"
                                >
                                    <i
                                        class="dx-theme-accent-as-text-color cc-1-5x margin-right-3px"
                                        [ngClass]="iconAttach"
                                    ></i>
                                </app-hyperlink-creator>
                            </div>

                            <div *dxTemplate="let data of 'notesTemplate'">
                                <app-notes-icon
                                    cssClass="cc-1-5x"
                                    title="Notes"
                                    [hasNotes]="data.value"
                                    (onNotesClick)="onItemNotesClick(data.data)"
                                ></app-notes-icon>
                            </div>

                            <div *dxTemplate="let data of 'logTemplate'">
                                <div class="link-content cc-hyperlink">
                                    <i
                                        class="cc-1-5x dx-theme-accent-as-text-color"
                                        [ngClass]="iconLog"
                                        (click)="onTransactionLogClick(data.data, lineItemLog)"
                                    ></i>
                                </div>
                            </div>

                            <div *dxTemplate="let row of 'booleanCellTemplate'">
                                <i *ngIf="row.value" class="cc-check-icon cc-1-5x" [ngClass]="iconCheck"></i>
                                <i *ngIf="!row.value" class="cc-text-required cc-1-5x" [ngClass]="iconClose"></i>
                            </div>

                            <div *dxTemplate="let header of 'lockHeaderCellTemplate'">
                                {{ header.column.caption }}
                                <app-security-info
                                    securityIndicator="LOCK"
                                    apiAction="PUT"
                                    apiUrl="api/acc"
                                ></app-security-info>
                            </div>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%" class="application-toolbar">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="iconClose"
                                (onClick)="onClosePopup()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                [icon]="iconSave"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-line-item-form-editor
    *ngIf="showLineItemFormEditor"
    [visible]="showLineItemFormEditor"
    [editorData]="editorData"
    [editlineItem]="lineItemData"
    (onLineItemAdd)="onLineItemAdd($event)"
    (onClose)="onLineItemEditorClose()"
></app-line-item-form-editor>

<app-application-change-owner-editor
    *ngIf="showChangeOwnerEditor"
    [visible]="showChangeOwnerEditor"
    [searchText]="searchText"
    [communityId]="communityId"
    (onOwnerSelect)="onOwnerSelection($event)"
    (onClose)="onChangeOwnerEditorClose()"
></app-application-change-owner-editor>

<app-board-approval-rules
    *ngIf="showBoardApprovalPopup"
    [visible]="showBoardApprovalPopup"
    [boardApprovalProcess]="editorData.boardApprovalRules"
    (closeBoardApprovalPopup)="showBoardApprovalPopup = false"
></app-board-approval-rules>

<app-architectual-application-notes-editor
    *ngIf="showNotesEditor"
    [visible]="showNotesEditor"
    [notesEditorParam]="notesEditorParam"
    [notesType]="notesType"
    (onNotesEditorClose)="onNoteSave($event)"
></app-architectual-application-notes-editor>

<app-architectural-application-transaction-log
    *ngIf="showTransactionLog"
    [visible]="showTransactionLog"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    (onTransactionLogClose)="showTransactionLog = false"
></app-architectural-application-transaction-log>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#accEditor' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-architectural-application-attachment-editor
    #attachmentEditor
    *ngIf="showAttachmentEditor"
    [visible]="showAttachmentEditor"
    [customerId]="customerId"
    [communityId]="communityId"
    [projectAttachments]="projectData.projectAttachments"
    [lineItemAttachment]="lineItemAttachment"
    [isProjectDocs]="isProjectDocs"
    [isItemDocs]="isItemDocs"
    [projectAccItemId]="projectAccItemId"
    [lineItemId]="lineItemId"
    [emailAttachments]="emailAttachments"
    (onDocumentUpdate)="onAttachmentUpdate($event)"
    (onClose)="onAttachmentClose($event)"
></app-architectural-application-attachment-editor>
